import { useState } from "react";
import NBATeamsList from "../../utils/teamData";
import CloseImage from "../../assets/images/close.svg";

function TeamPickerModal(props) {
    const [selectedTeam, setSelectedTeam] = useState(null);
    
    return (
        <div id="team-picker-modal-container" className="modal-container">
            <div id="team-picker-modal">
                <div id="team-picker-modal-header">
                    <div className="header-title">Select your favorite team</div>    
                </div>
                <div className="close-btn-container">
                    <button onClick={() => { props.closeModal(); }}>
                        <img alt="close" className="close-modal-btn" src={CloseImage}/>
                    </button>
                </div>
                <div id="team-picker-modal-content">
                    { NBATeamsList.map((team, i) => 
                        <div className="team-option" key={i} onClick={() => setSelectedTeam(team)}>
                            <div className="team-name">
                                <div className={`team-logo ${team.tricode.toLowerCase()}`} />
                                {team.city} {team.name}
                            </div>
                            <div className={`outer-radio ${selectedTeam && team.id === selectedTeam.id ? 'selected' : ''}`}>
                                <div className="inner-radio"></div>
                            </div>
                        </div>
                    )}
                </div>
                <div id="team-picker-modal-footer">
                    <button id="submit-btn" onClick={() => props.submit(selectedTeam)} disabled={!selectedTeam} data-track="click" data-id="nba:membership-hub:choose-favorite-team:submit"
                    data-type="button" data-text="Submit" data-content={selectedTeam ? selectedTeam.tricode : null} data-content-id={selectedTeam ? selectedTeam.id : null}>
                        Submit
                    </button>
                </div>
            </div>
        </div>
    )
};

export default TeamPickerModal;
